import React from 'react';
import {TextField, TextFieldProps} from "@mui/material";
import TextFieldWithDirtyValidation from "./TextFieldWithDirtyValidation";

interface PhoneNumberTextFieldProps extends Omit<TextFieldProps, 'type'> {
  label?: string;
  name?: string;
  placeholder?: string;
}

const PhoneNumberTextField = React.forwardRef<HTMLInputElement, PhoneNumberTextFieldProps>(
  (props, ref) => {
    const {label, name, placeholder, ...otherProps} = props;
    return (
      <TextField
        {...otherProps}
        inputRef={ref}
        label={label || "Phone Number"}
        name={name || "phoneNumber"}
        placeholder={placeholder || "Enter your phone number"}
        type="tel"
      />
    );
  });
PhoneNumberTextField.displayName = 'PhoneNumberTextField';

const PhoneNumberTextFieldWithDirtyValidation = React.forwardRef<HTMLInputElement, PhoneNumberTextFieldProps>(
  (props, ref) => {
    const {label, name, placeholder, ...otherProps} = props;
    return (
      <TextFieldWithDirtyValidation
        {...otherProps}
        ref={ref}
        label={label || "Phone Number"}
        name={name || "phoneNumber"}
        placeholder={placeholder || "Enter your phone number"}
        type="tel"
      />
    );
  });
PhoneNumberTextFieldWithDirtyValidation.displayName = 'PhoneNumberTextFieldWithDirtyValidation';

export {
  PhoneNumberTextField,
  PhoneNumberTextFieldWithDirtyValidation
};
